<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area esg05">
      <img
        :src="`${resources}img/img-top-sub-title16_new.jpg`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">ESG 게시판</div>
        <div class="sub_txt">
          지속가능경영을 위해 환경(E), 사회(S), 지배구조(G) 개선 활동을 적극
          추진하고 있습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->
    <div class="tab_area" :class="{ renew: device === 'mo' }">
      <div class="tab_item">
        <a
          class="t-toggle__button"
          :class="{ active: tabID === '0' }"
          href="#"
          @click.prevent="tabClick(0)"
          >전체</a
        >
        <a
          class="t-toggle__button"
          :class="{ active: tabID === '1' }"
          href="#"
          @click.prevent="tabClick(1)"
          >윤리경영</a
        >
        <a
          class="t-toggle__button"
          :class="{ active: tabID === '2' }"
          href="#"
          @click.prevent="tabClick(2)"
          >나눔경영</a
        >
        <a
          class="t-toggle__button"
          :class="{ active: tabID === '3' }"
          href="#"
          @click.prevent="tabClick(3)"
          >안전&middot;보건&middot;환경</a
        >
        <a
          class="t-toggle__button"
          :class="{ active: tabID === '4' }"
          href="#"
          @click.prevent="tabClick(4)"
          >품질경영</a
        >
      </div>
    </div>
    <!-- sub contents -->
    <div class="sub_contents">
      <div class="tbl_scroll_area tbl_min" v-if="device === 'mo'">
        <div class="tbl_ty02 bod" v-if="viewMode === view.LIST">
          <table>
            <caption>
              분류,제목,작성일
            </caption>
            <colgroup>
              <col style="width: 24%" />
              <col style="width: auto" />
              <col style="width: 20%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">분류</th>
                <th scope="col">제목</th>
                <th scope="col">작성일</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in listItems" :key="`inverst-tr-${idx}`">
                <td v-html="getNo(item.type)"></td>
                <td class="aLeft">
                  <a href="#" @click.prevent="clickBbs(item.seq)">{{
                    item.title
                  }}</a>
                </td>
                <td>{{ getDate(item.title) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="detailView" v-else>
          <div class="notice_board">
            <dl>
              <dt class="notice_tit">
                <h4 ref="title"></h4>
                <span ref="date"></span>
              </dt>
              <dd>
                <div class="board_con" ref="boardCon"></div>
                <dl class="board_attach" ref="boardAttach">
                  <dt>첨부파일</dt>
                  <dd>
                    <ul>
                      <li>
                        <a href="file:" @click.prevent="download(seq)"
                          ><span ref="attachFileName"></span
                        ></a>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </dd>
            </dl>
          </div>
          <div class="btn_rht_wrap mt_50">
            <button type="button" class="btn_blue2" @click.prevent="listView()">
              목록
            </button>
          </div>
        </div>
      </div>

      <div class="tbl_ty02 bod" v-else>
        <div v-if="viewMode === view.LIST">
          <table>
            <caption>
              공시정보: 분류,제목,작성일,작성자로 구성
            </caption>
            <colgroup>
              <col style="width: 20%" />
              <col style="width: auto" />
              <col style="width: 20%" />
              <!-- <col style="width: 20%" /> -->
            </colgroup>
            <thead>
              <tr>
                <th scope="col">분류</th>
                <th scope="col">제목</th>
                <th scope="col">작성일</th>
                <!-- <th scope="col">작성자</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in listItems" :key="`inverst-tr-${idx}`">
                <td v-html="getNo(item.type)"></td>
                <td class="aLeft">
                  <a href="#" @click.prevent="clickBbs(item.seq)">{{
                    item.title
                  }}</a>
                </td>
                <td>{{ getDate(item.reg_date) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="detailView" v-else>
          <div class="notice_board">
            <dl>
              <dt class="notice_tit">
                <h4 ref="title"></h4>
                <span ref="date"></span>
              </dt>
              <dd>
                <div class="board_con" ref="boardCon"></div>
                <dl class="board_attach" ref="boardAttach">
                  <dt>첨부파일</dt>
                  <dd>
                    <ul>
                      <li>
                        <a href="file:" @click.prevent="download(seq)"
                          ><span ref="attachFileName"></span
                        ></a>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </dd>
            </dl>
          </div>
          <div class="btn_rht_wrap mt_50">
            <button type="button" class="btn_blue2" @click.prevent="listView()">
              목록
            </button>
          </div>
        </div>
      </div>

      <div
        class="btn_cnt_wrap"
        v-if="device === 'mo' && this.currentLen !== this.totalPageN"
        @click.prevent="changePage(showPageLabel(curPageIdx + 1) - 1)"
      >
        <button
          type="button"
          class="btn_morelist"
          v-show="viewMode === view.LIST"
        >
          더보기
        </button>
      </div>
      <!-- paging -->
      <div class="paging_item" v-if="device === 'pc' && viewMode === view.LIST">
        <div class="btn_area">
          <a
            href="#"
            :class="['btn_first', { inactive: isFirst }]"
            @click.prevent="firstPage($event)"
            >첫페이지</a
          >
          <a
            href="#"
            :class="['btn_prev', { inactive: isFirst }]"
            @click.prevent="prevPage($event)"
            >이전</a
          >
        </div>

        <div class="paging">
          <a
            v-for="(item, idx) in viewPageLength"
            :class="{ active: isCurrent(idx) }"
            :key="`paging-atag-${idx}`"
            href="#"
            @click.prevent="changePage(showPageLabel(idx) - 1)"
            >{{ showPageLabel(idx) }}</a
          >
        </div>
        <div class="btn_area">
          <a
            href="#"
            :class="['btn_next', { inactive: isLast }]"
            @click.prevent="nextPage($event)"
            >다음</a
          >
          <a
            href="#"
            :class="['btn_last', { inactive: isLast }]"
            @click.prevent="lastPage($event)"
            >마지막페이지</a
          >
        </div>
      </div>
      <!-- paging -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>
<script>
import invest026 from './p_esg026';
export default invest026;
</script>

<style lang="scss" scoped>
.tabList {
  list-style: none outside none;
  margin: 0;
  padding: 0;
}
.tabList li {
  float: left;
  margin: 0 10px;
}
</style>
